export async function verifyTokenOnServer({ token, action, siteKey, endpoint }) {
  const url = endpoint || process.env.REACT_APP_VERIFY_RECAPTCHA_URL;
  if (!url) {
    // No server configured; skip server verification
    return { ok: true, skipped: true };
  }
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event: { token, expectedAction: action, siteKey } }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    return { ok: false, error: `verify http ${res.status}`, details: text };
  }
  const data = await res.json().catch(() => ({}));
  return data;
}
